const p1= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#CF3830', '#CF4530', '#CF5D30', '#CF7430', '#CF8E30', '#CFA230', '#CFB930', '#C3CF30', '#B2CF30', '#9BCF30',
    '#86CF30', '#69CF30', '#4ECF30', '#37CF30', '#30CF47', '#30CF58', '#30CF6C', '#30CF91', '#30CFA1', '#30CFB8',
    '#30CFC7', '#30BACF', '#309FCF', '#308CCF', '#3073CF', '#3061CF', '#303FCF', '#3031CF', '#5930CF', '#6830CF',
    '#8430CF', '#9830CF', '#AA30CF', '#CE30CF', '#CF30C3', '#CF30AD', '#CF308B', '#CF3072', '#CF3063', '#CF3048'
]};

const p2= {backCollor:'#FFFFFF', labelCollor:'#111827', palette:[
    '#E8A4A0', '#E8A9A0', '#E8B2A0', '#E8BEA0', '#E8C8A0', '#E8D2A0', '#E8DFA0', '#E2E8A0', '#D7E8A0', '#CBE8A0',
    '#BEE8A0', '#B0E8A0', '#A4E8A0', '#A0E8AA', '#A0E8B6', '#A0E8C3', '#A0E8D0', '#A0E8DE', '#A0E2E8', '#A0D6E8',
    '#A0C9E8', '#A0BDE8', '#A0B0E8', '#A0A4E8', '#A9A0E8', '#B5A0E8', '#C2A0E8', '#CFA0E8', '#DEA0E8', '#E8A0E2',
    '#E8A0D6', '#E8A0CA', '#E8A0BE', '#E8A0B2', '#E8A0A5', '#E8A0A0', '#E8A0A4', '#E8A0AC', '#E8A0B7', '#E8A0A9'
]};

const p3= {backCollor:'#F5F7FA', labelCollor:'#111827', palette:[
    '#B85C55', '#B86655', '#B87955', '#B88C55', '#B8A155', '#B8B455', '#ADB855', '#97B855', '#7FB855', '#67B855',
    '#55B865', '#55B879', '#55B88D', '#55B8A2', '#55B8B5', '#55A9B8', '#5592B8', '#557EB8', '#5567B8', '#5D55B8',
    '#7455B8', '#8D55B8', '#A355B8', '#B855B0', '#B85599', '#B85582', '#B8556B', '#B8555D', '#B85555', '#B85E55',
    '#B86B55', '#B88355', '#B89A55', '#B8AA55', '#AEB855', '#9DB855', '#86B855', '#6FB855', '#58B855', '#55B862'
]};

const p4= {backCollor:'#0B0F14', labelCollor:'#E5E7EB', palette:[
    '#E02C20', '#E03B20', '#E05720', '#E07220', '#E08F20', '#E0A620', '#E0C120', '#CCE020', '#B2E020', '#8EE020',
    '#74E020', '#51E020', '#20E02C', '#20E051', '#20E06A', '#20E08A', '#20E0B0', '#20E0D0', '#20CDE0', '#20AEE0',
    '#2092E0', '#2074E0', '#2051E0', '#3B20E0', '#5B20E0', '#7E20E0', '#A220E0', '#D020E0', '#E020C9', '#E020AB',
    '#E0208A', '#E02074', '#E02051', '#E02039', '#E02020', '#E02A20', '#E03D20', '#E05820', '#E07220', '#E03B20'
]};

const p5= {backCollor:'#111827', labelCollor:'#F9FAFB', palette:[
    '#E01B10', '#E02A10', '#E04410', '#E05F10', '#E07C10', '#E09510', '#E0B110', '#D6E010', '#BDE010', '#9BE010',
    '#7EE010', '#5DE010', '#35E010', '#10E01B', '#10E044', '#10E06A', '#10E095', '#10E0B9', '#10E0DA', '#10CFE0',
    '#10A8E0', '#1089E0', '#106AE0', '#1048E0', '#3510E0', '#5C10E0', '#8610E0', '#B610E0', '#E010D6', '#E010B5',
    '#E01089', '#E0106A', '#E01048', '#E0102A', '#E01010', '#E01810', '#E02B10', '#E04510', '#E06010', '#E02A10'
]};

const p6= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#EAF2FF', '#E4EEFF', '#DEEAFF', '#D8E6FF', '#D2E2FF', '#CCDEFF', '#C6DAFF', '#C0D6FF', '#BAD2FF', '#B4CEFF',
    '#AECAFF', '#A8C6FF', '#A2C2FF', '#9CBFFF', '#96BBFF', '#90B7FF', '#8AB3FF', '#84AFFF', '#7EABFF', '#78A7FF',
    '#72A3FF', '#6C9FFF', '#669BFF', '#6097FF', '#5A93FF', '#548FFF', '#4E8BFF', '#4887FF', '#4283FF', '#3C7FFF',
    '#367BFF', '#3077FF', '#2A73FF', '#246FFF', '#1E6BFF', '#1867FF', '#1263FF', '#0C5FFF', '#065BFF', '#0057FF'
]};

const p7= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#E9FBFF', '#E1F8FF', '#DAF5FF', '#D2F2FF', '#CAEFFF', '#C3ECFF', '#BBE9FF', '#B3E6FF', '#ABE3FF', '#A4E0FF',
    '#9CDDFE', '#94DAFE', '#8CD7FE', '#85D4FE', '#7DD1FE', '#75CEFE', '#6DCBFE', '#66C8FE', '#5EC5FE', '#56C2FE',
    '#4EBFFE', '#47BCFE', '#3FB9FE', '#37B6FE', '#2FB3FE', '#28B0FE', '#20ADFE', '#18AAFE', '#10A7FE', '#09A4FE',
    '#01A1FE', '#009EFB', '#009BF4', '#0098EC', '#0095E4', '#0092DC', '#008FD4', '#008CCC', '#0089C4', '#0086BC'
]};

const p8= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#ECFDF3', '#E6FBEF', '#E0F9EB', '#DAF7E7', '#D4F5E3', '#CEF3DF', '#C8F1DB', '#C2EFD7', '#BCEED3', '#B6ECCE',
    '#B0EAC9', '#AAE8C4', '#A4E6BF', '#9EE4BA', '#98E2B5', '#92E0B0', '#8CDEAB', '#86DCA6', '#80DAA1', '#7AD89C',
    '#74D697', '#6ED492', '#68D28D', '#62D088', '#5CCE83', '#56CC7E', '#50CA79', '#4AC874', '#44C66F', '#3EC46A',
    '#38C265', '#32C060', '#2CBE5B', '#26BC56', '#20BA51', '#1AB84C', '#14B647', '#0EB442', '#08B23D', '#02B038'
]};

const p9= {backCollor:'#FFFBF5', labelCollor:'#1F2937', palette:[
    '#FFF1E5', '#FFEBDD', '#FFE5D5', '#FFDFCD', '#FFD9C5', '#FFD3BD', '#FFCCB5', '#FFC6AD', '#FFC0A5', '#FFBA9D',
    '#FFB395', '#FFAD8D', '#FFA785', '#FFA17D', '#FF9B75', '#FF956D', '#FF8F65', '#FF895D', '#FF8355', '#FF7D4D',
    '#FF7745', '#FF713D', '#FF6B35', '#FF652D', '#FF5F25', '#FF591D', '#FF5315', '#FF4D0D', '#FF4705', '#FF4100',
    '#F73C00', '#EF3700', '#E73200', '#DF2D00', '#D72800', '#CF2300', '#C71E00', '#BF1900', '#B71400', '#AF0F00'
]};

const p10= {backCollor:'#FBFAFF', labelCollor:'#111827', palette:[
    '#F6F1FF', '#F1EAFF', '#ECE3FF', '#E7DCFF', '#E2D5FF', '#DDCEFF', '#D8C7FF', '#D3C0FF', '#CEB9FF', '#C9B2FF',
    '#C4ABFF', '#BFA4FF', '#BA9DFF', '#B596FF', '#B08FFF', '#AB88FF', '#A681FF', '#A17AFF', '#9C73FF', '#976CFF',
    '#9265FF', '#8D5EFF', '#8857FF', '#8350FF', '#7E49FF', '#7942FF', '#743BFF', '#6F34FF', '#6A2DFF', '#6526FF',
    '#601FFF', '#5B18FF', '#5611FF', '#510AFF', '#4C03FF', '#4700F7', '#4200EF', '#3D00E7', '#3800DF', '#3300D7'
]};

const p11= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#8F0B00', '#9D1607', '#AB2310', '#B9331A', '#C64526', '#D35934', '#DF6F45', '#EA8759', '#F3A170', '#F9BC8A',
    '#FDD7A7', '#FFF1C7', '#F5F7F9', '#D9E6F4', '#BCD5EF', '#9FC4EA', '#82B3E5', '#66A2E0', '#4B91DB', '#337FD6',
    '#216CCF', '#1758C1', '#1246AB', '#0F3793', '#0E2B7A', '#0D2265', '#0C1B52', '#0B163F', '#0A112E', '#090C1F',
    '#080812', '#07060C', '#060507', '#050403', '#040302', '#030201', '#020101', '#010001', '#000000', '#000000'
]};

const p12= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#3A0B6F', '#45147A', '#4F1F85', '#5A2C90', '#653A9B', '#704AA6', '#7B5CB1', '#866FBC', '#9185C7', '#9D9ED2',
    '#AAB9DD', '#B8D6E8', '#F5F7F9', '#D9F1DC', '#BCEAC0', '#9FE3A4', '#82DC88', '#66D56E', '#4BCE56', '#33C740',
    '#21BE2F', '#17B022', '#12921B', '#0F7216', '#0E5713', '#0D430F', '#0C320C', '#0B250A', '#0A1A07', '#091106',
    '#080B04', '#070703', '#060502', '#050401', '#040301', '#030201', '#020101', '#010001', '#000000', '#000000'
]};

const p13= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#7A2A00', '#853508', '#914211', '#9D511B', '#A96227', '#B57536', '#C28A49', '#CEA05F', '#DAB978', '#E5D395',
    '#F0EEB6', '#F8F7DB', '#F5F7F9', '#D7F0F2', '#B7E7E7', '#98DEDC', '#79D5D1', '#5BCBC6', '#40C1BB', '#2BB6AF',
    '#1AA9A2', '#139995', '#0F7F7A', '#0D645F', '#0C4D48', '#0B3B36', '#0A2B27', '#091F1C', '#081613', '#070F0C',
    '#060A07', '#050604', '#040402', '#030301', '#020101', '#010001', '#000000', '#000000', '#000000', '#000000'
]};

const p14= {backCollor:'#0B0F14', labelCollor:'#E5E7EB', palette:[
    '#5A2A00', '#673408', '#744011', '#824E1C', '#8F5E28', '#9C7038', '#A9834B', '#B59962', '#C1B07D', '#CCD09C',
    '#D6F0C0', '#E2FFD9', '#F0F2F4', '#D4E2F0', '#B7D2EB', '#9AC2E6', '#7EB2E1', '#63A2DC', '#4B91D7', '#357FD1',
    '#256CC9', '#1A58BE', '#1546A7', '#12358F', '#102B75', '#0F225F', '#0E1B4C', '#0D163C', '#0C112E', '#0B0D21',
    '#0A0A17', '#09070F', '#080508', '#070304', '#060202', '#050101', '#040000', '#030000', '#020000', '#010000'
]};

const p15= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#440154', '#440357', '#45065A', '#450A5C', '#460D5F', '#461161', '#471463', '#471A65', '#481D67', '#48206A',
    '#48246C', '#48276E', '#492A70', '#492D72', '#493074', '#46347B', '#42387F', '#3F3C82', '#3B3F86', '#384289',
    '#34468D', '#314A8F', '#2E4E91', '#2B5194', '#275696', '#245A98', '#215D9A', '#1E619C', '#1A659E', '#1769A0',
    '#146CA2', '#1171A4', '#0D74A6', '#0A78A8', '#097D9E', '#0A818F', '#0C867E', '#118B6D', '#1E904E', '#2A9240'
]};

const p16= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#0D0887', '#140A8D', '#1B0C93', '#220D98', '#290E9D', '#2F109F', '#3511A1', '#3B129E', '#41139B', '#471495',
    '#4C158F', '#521689', '#571784', '#5C187E', '#611A78', '#661B72', '#6B1C6D', '#701D67', '#751E61', '#7A1F5B',
    '#7F2056', '#842151', '#89224C', '#8F2346', '#952440', '#9B263A', '#A22833', '#AA2A2C', '#B22C25', '#BA2F1E',
    '#C23216', '#CA350F', '#D23907', '#D93D02', '#DF4100', '#E54500', '#EA4A00', '#EF4F00', '#F45400', '#F95A00'
]};

const p17= {backCollor:'#0B0F14', labelCollor:'#E5E7EB', palette:[
    '#000004', '#050416', '#0B0923', '#110B2E', '#170B39', '#1C0C44', '#220C4F', '#270B59', '#2C0B62', '#310A6B',
    '#360A73', '#3B096C', '#40095F', '#450951', '#4A0944', '#4F0A37', '#540A2C', '#5A0A22', '#600B19', '#660B11',
    '#6C0B0A', '#720B05', '#780B03', '#7E0B02', '#840B02', '#8A0B03', '#900B06', '#960B0A', '#9C0B10', '#A20B18',
    '#A80B21', '#AE0B2C', '#B40B38', '#BA0B45', '#C00B53', '#C60B62', '#CC0B72', '#D20B83', '#D80B95', '#DE0BA8'
]};

const p18= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#00224E', '#052B55', '#0A345B', '#0F3D61', '#144767', '#18506D', '#1D5973', '#226279', '#266B7E', '#2B7484',
    '#307D8A', '#34868F', '#398F95', '#3E989A', '#43A19F', '#48AAA4', '#4DB3A9', '#52BCAE', '#57C5B3', '#5DCEB8',
    '#63D7BC', '#69E0C1', '#6FE9C6', '#75F2CB', '#7BFBCE', '#82FFD2', '#8BFFD5', '#94FFD9', '#9DFFDC', '#A6FFDF',
    '#AFFF E2'.replace(' ',''), '#B8FFE5', '#C1FFE8', '#CAFFEB', '#D3FFEE', '#DCFFF1', '#E5FFF4', '#EEFFF7', '#F7FFFA', '#FFFFFD'
]};

const p19= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#30123B', '#351B4C', '#3A245D', '#3E2D6D', '#43367E', '#473F8E', '#4C489F', '#5052AF', '#555BBF', '#5964CF',
    '#5E6DDF', '#6276EF', '#6680FF', '#5C8CFF', '#5298FF', '#48A3FF', '#3EAEFF', '#34B8FF', '#2AC2FF', '#20CCFF',
    '#16D5FF', '#0CDEFF', '#02E7FF', '#00F0F7', '#00F8E7', '#00FFD6', '#1BFFC1', '#37FFAB', '#53FF95', '#6FFF7F',
    '#8BFF69', '#A7FF53', '#C3FF3D', '#DFFF27', '#FBFF10', '#FFEE0A', '#FFD904', '#FFC100', '#FFA800', '#FF8F00'
]};
const p20= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#3B4CC0', '#3F53C6', '#435ACC', '#4761D2', '#4B68D8', '#4F6FDE', '#5376E4', '#577DEA', '#5B84F0', '#5F8BF6',
    '#6392FC', '#6799FF', '#6EA0FF', '#76A7FF', '#7EAEFF', '#87B4FF', '#90BAFF', '#9AC0FF', '#A4C6FF', '#AFCBFF',
    '#BBD0FF', '#C7D4FF', '#D3D8FF', '#E0DBFF', '#EDE0F2', '#F4D6DC', '#F7C9C0', '#F6B9A5', '#F3A589', '#EE8E6E',
    '#E7765B', '#DD5D50', '#D24745', '#C6373A', '#B72B2F', '#A51E25', '#92141C', '#7E0D13', '#6A070B', '#560004'
]};

const p21= {backCollor:'#F8FAFC', labelCollor:'#0F172A', palette:[
    '#9E0142', '#B20B4A', '#C61552', '#DA1F5A', '#EE2962', '#F43D6B', '#F85174', '#FB667D', '#FD7B86', '#FE908F',
    '#FEA598', '#FDBAA1', '#FDCFAB', '#FDE4B5', '#FEF2C0', '#F5FBC6', '#E6F4B8', '#D8EDA9', '#CAE69A', '#BCE08B',
    '#AED97C', '#A0D26D', '#91CB5E', '#83C44F', '#75BE40', '#67B731', '#59B122', '#4BAA13', '#3DA404', '#2F9D00',
    '#239300', '#1A8600', '#137A00', '#0E6F00', '#0A6500', '#075B00', '#055100', '#034700', '#023D00', '#013300'
]};

const p22= {backCollor:'#FFFCF7', labelCollor:'#1F2937', palette:[
    '#C35C33', '#C36433', '#C37033', '#C38033', '#C39133', '#C3A433', '#C3B933', '#B7C333', '#A3C333', '#8FC333',
    '#7BC333', '#65C333', '#33C35C', '#33C376', '#33C391', '#33C3AE', '#33C3C3', '#33AEC3', '#3390C3', '#337AC3',
    '#3365C3', '#3E33C3', '#5A33C3', '#7633C3', '#9133C3', '#AE33C3', '#C333B7', '#C333A3', '#C3338F', '#C3337B',
    '#C33365', '#C33E33', '#C34E33', '#C35E33', '#C36E33', '#C38133', '#C39233', '#C3A333', '#C3B533', '#C3C033'
]};

const p23= {backCollor:'#F6FAFF', labelCollor:'#0F172A', palette:[
    '#3368C3', '#336FC3', '#337BC3', '#3388C3', '#3396C3', '#33A7C3', '#33B9C3', '#33C3B7', '#33C3A3', '#33C38F',
    '#33C37B', '#33C365', '#33C34E', '#33C33E', '#3EC333', '#5AC333', '#76C333', '#91C333', '#AEC333', '#C3C033',
    '#C3B533', '#C3A333', '#C39233', '#C38133', '#C36E33', '#C35E33', '#C34E33', '#C33E33', '#C33365', '#C3337B',
    '#C3338F', '#C333A3', '#C333B7', '#B933C3', '#A733C3', '#9633C3', '#8833C3', '#7B33C3', '#6F33C3', '#6833C3'
]};

const p24= {backCollor:'#FFFFFF', labelCollor:'#111827', palette:[
    '#1E1E1E', '#282828', '#323232', '#3C3C3C', '#464646', '#505050', '#5A5A5A', '#646464', '#6E6E6E', '#787878',
    '#828282', '#8C8C8C', '#969696', '#A0A0A0', '#AAAAAA', '#B4B4B4', '#BEBEBE', '#C8C8C8', '#D2D2D2', '#DCDCDC',
    '#30A8CF', '#3092CF', '#3073CF', '#303FCF', '#5930CF', '#8430CF', '#AA30CF', '#CF30AD', '#CF308B', '#CF3072',
    '#CF5D30', '#CF8E30', '#CFB930', '#B2CF30', '#86CF30', '#4ECF30', '#30CF6C', '#30CFA1', '#30CFC7', '#30BACF'
]};

const p25= {backCollor:'#0B0F14', labelCollor:'#E5E7EB', palette:[
    '#19D35C', '#1BD15A', '#1DCF58', '#1FCD56', '#21CB54', '#23C952', '#25C750', '#27C54E', '#29C34C', '#2BC14A',
    '#2DBF48', '#2FBD46', '#31BB44', '#33B942', '#35B740', '#37B53E', '#39B33C', '#3BB13A', '#3DAF38', '#3FAD36',
    '#41AB34', '#43A932', '#45A730', '#47A52E', '#49A32C', '#4BA12A', '#4D9F28', '#4F9D26', '#519B24', '#539922',
    '#559720', '#57951E', '#59931C', '#5B911A', '#5D8F18', '#5F8D16', '#618B14', '#638912', '#658710', '#67850E'
]};
export const myPalette =p12